const $$splitComponentImporter = () => import('/home/runner/work/touring-host-app/touring-host-app/src/routes/_rootLayout/persons/$id.reports.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { getGetAllReportConfigurationsQueryOptions, getGetReportHistoryQueryOptions } from '@api';
import { hasPermission } from '@hypeit-gmbh/hypeit-ui-core';
import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/_rootLayout/persons/$id/reports')({
  beforeLoad: ({
    context: {
      permissions
    }
  }) => {
    if (!hasPermission(permissions, {
      permission: 'REPORTS',
      action: 'READ'
    })) {
      throw redirect({
        to: '/',
        replace: true,
        throw: true
      });
    }
  },
  loader: async ({
    context: {
      queryClient
    },
    params: {
      id
    }
  }) => {
    queryClient.ensureQueryData(getGetAllReportConfigurationsQueryOptions({
      personId: id
    }));
    queryClient.ensureQueryData(getGetReportHistoryQueryOptions({
      personId: id
    }));
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});